export const AUTH_TOKEN = "auth_token";

